document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".section-contacts").forEach((section) => {
        const coordButtons = section.querySelectorAll('.coords');
        coordButtons.forEach(button => {
            button.addEventListener('click', () => {
                const targetCount = button.getAttribute('data-count');
                section.querySelectorAll('.coords-element').forEach(element => {
                    element.classList.remove('active');
                });

                const targetElement = section.querySelector(`.coords-element[data-count="${targetCount}"]`);
                if (targetElement) {
                    targetElement.classList.add('active');
                }
            });
        });
    })
});

